<template>
  <v-list-item
    class="list-item"
    data-testid="list-item"
    :key="team.id"
    @click="$emit('click', team)"
  >
    <v-list-item-avatar class="d-flex justify-center ma-0">
      <v-avatar color="blue lighten-2" size="24">
        <v-icon color="blue" size="14">
          mdi-account-group
        </v-icon>
      </v-avatar>
    </v-list-item-avatar>

    <v-list-item-content class="pt-1 pb-1">
      <div class="d-flex align-center justify-space-between overflow-hidden">
        <div class="flex-grow-0 flex-shrink-1 overflow-hidden">
          <v-list-item-title class="font-size-13 name">
            <text-highlight
              highlightClass="yellow lighten-1"
              data-private
              highlightComponent="span"
              :queries="searchTerm || ''"
            >
              {{ team.title }}
            </text-highlight>
          </v-list-item-title>
          <p class="ma-0 font-size-10 blue-grey--text subtitle">
            {{ team.subtitle }}
          </p>
        </div>

        <v-icon
          v-if="selected"
          class="flex-grow-0 flex-shrink-0"
          color="blue"
          size="20"
          >mdi-check-circle</v-icon
        >
      </div>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
export default {
  name: 'TeamListItem',

  props: {
    team: Object,
    searchTerm: String,
    selected: Boolean,
  },
}
</script>

<style scoped lang="scss">
.name {
  line-height: 20px !important;
}

.subtitle {
  line-height: 16px !important;
}

.list-item.v-list-item::before,
.list-item.v-list-item:hover {
  border-radius: 4px !important;
  background-color: $color-blue-grey-lighten3;
}
</style>
